
import React, { createContext, useContext, useState, useEffect } from "react";

// create context
const AppContext = createContext(null);

export default function AppProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const [currentSessionIndex, setCurrentSessionIndex] = useState(0);
  const [chatQuery, setChatQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [voiceMode, setVoiceMode] = useState(false);
  const [showVoiceModal, setShowVoiceModal] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [query, setQuery] = useState("");
  const [draftingNewChat, setDraftingNewChat] = useState(false);
//   const baseUrl = import.meta.env.VITE_API_URL;

   const fetchCallerData = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_PATH}/get-caller`
      );
      if (!res.ok) throw new Error("Failed to fetch caller data");

      const data = await res.json();
      if (data) {
        setChatHistory(data[0].chatSessions || []);
      }
    } catch (err) {
      console.error("Error fetching caller data:", err);
    }
  };

  const value = {
    chatHistory,
    setChatHistory,
    loading,
    setLoading,
    query,
    setQuery,
    currentSessionIndex,
    setCurrentSessionIndex,
    draftingNewChat,
    setDraftingNewChat,
    fetchCallerData,
    chatQuery,
    setChatQuery,
    searchResults,
    setSearchResults,
    open,
    setOpen,
    voiceMode,
    setVoiceMode,
    showVoiceModal,
    setShowVoiceModal,
    transcript,
    setTranscript,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

//custom hook
export function useApp() {
  const ctx = useContext(AppContext);
  return ctx;
}
